import * as React from "react";
import * as ReactDOM from "react-dom";
import Commonnav from "@/layouts/commonnav/commonnav";
import ZeusZeusPowerCenterList from "@/widgets/zeus_zeus_power_center_list";
import ZeusZeusPowerCenterListData from "./data/zeus_zeus_power_center_list/data";

class Home extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Commonnav>
        <div className="jdw-container">
          <div className="jdw-row">
            <div className="jdw-column">
              <div className="jdw-widget" data-name="zeus_zeus_power_center_list" data-version="2.0.1">
                <ZeusZeusPowerCenterList {...ZeusZeusPowerCenterListData} />
              </div>
            </div>
          </div>
        </div>
      </Commonnav>
    );
  }
}

ReactDOM.render(<Home />, document.getElementById("root"));
